const digitsOnly = value =>
  typeof value === "string" ? value.replace(/\D/g, "") : "";

const getContactPhoneNumber = contact => {
  const number =
    typeof contact?.number === "string" ? contact.number.trim() : "";
  const lidDigits = digitsOnly(contact?.lid);

  if (!number || (lidDigits && digitsOnly(number) === lidDigits)) {
    return "";
  }

  return number;
};

export default getContactPhoneNumber;
